function meterIsNoMatch(question: any): boolean {
    return question &&
        question.answer?.text && question.expectedValue &&
        question.answer?.text !== question.expectedValue;
}
export default meterIsNoMatch;
